import { useLang } from "../../context/LanguageContext";

interface SectionExitModalProps {
  sectionKey: string;
  onClose: () => void;
  onAdvance: () => void;
  /**
   * Secondary action — e.g. return to Document Organizer instead of staying on this section.
   * When omitted, the secondary button uses `onClose` (dismiss modal only).
   */
  onComeBackLater?: () => void;
}

export default function SectionExitModal(props: SectionExitModalProps) {
  const { onClose, onAdvance, onComeBackLater } = props;
  const { t } = useLang();

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4"
      style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
      onClick={onClose}
    >
      <style>{`@keyframes fadeScale { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }`}</style>
      <div
        className="w-full max-w-[420px] max-h-[90vh] overflow-y-auto bg-white rounded-2xl px-5 pt-5 pb-6 shadow-2xl"
        style={{ animation: "fadeScale 0.2s ease-out" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-[17px] font-semibold text-slate-900 mb-1">{t("sectionExit.porMarkTitle")}</h3>
        <p className="text-[13px] text-slate-500 mb-5 leading-snug">{t("sectionExit.porMarkSubtitle")}</p>

        <div className="flex flex-col gap-2.5">
          <button
            type="button"
            onClick={onAdvance}
            className="w-full py-3.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-[15px] font-medium cursor-pointer transition-colors whitespace-nowrap"
          >
            {t("sectionExit.porMarkComplete")}
          </button>
          <button
            type="button"
            onClick={onComeBackLater ?? onClose}
            className="w-full py-3.5 rounded-xl bg-white border border-slate-200 hover:border-slate-300 text-slate-700 text-[15px] font-medium cursor-pointer transition-colors whitespace-nowrap"
          >
            {t("sectionExit.porComeBackLater")}
          </button>
        </div>
      </div>
    </div>
  );
}
